export const aerospikeConfig = {
    hosts: process.env.BUILD_ENV === 'prod' ? 'grd-aspk-cabs-seo-1.goibibo.com,grd-aspk-cabs-seo-2.goibibo.com,grd-aspk-cabs-seo-3.goibibo.com' : '10.212.17.206',
}

